"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('@angular/common');

var _c0 = function (a0, a1, a2, a3) { return { "active": a0, "enabled": a1, "disabled": a2, "completed": a3 }; };
function WizardComponent_li_3_Template(rf, ctx) { if (rf & 1) {
    var _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 8);
    ɵngcc0.ɵɵelementStart(1, "a", 9);
    ɵngcc0.ɵɵlistener("click", function WizardComponent_li_3_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r3); var step_r1 = ctx.$implicit; var ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.goToStep(step_r1); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var step_r1 = ctx.$implicit;
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction4(2, _c0, step_r1.isActive, !step_r1.isDisabled, step_r1.isDisabled, ctx_r0.isCompleted));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(step_r1.title);
} }
var _c1 = ["*"];
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var wizard_step_component_1 = require("./wizard-step.component");
var WizardComponent = (function () {
    function WizardComponent() {
        this._steps = [];
        this._isCompleted = false;
        this.onStepChanged = new core_1.EventEmitter();
    }
    WizardComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.wizardSteps.forEach(function (step) { return _this._steps.push(step); });
        this.steps[0].isActive = true;
    };
    Object.defineProperty(WizardComponent.prototype, "steps", {
        get: function () {
            return this._steps.filter(function (step) { return !step.hidden; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WizardComponent.prototype, "isCompleted", {
        get: function () {
            return this._isCompleted;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WizardComponent.prototype, "activeStep", {
        get: function () {
            return this.steps.find(function (step) { return step.isActive; });
        },
        set: function (step) {
            if (step !== this.activeStep && !step.isDisabled) {
                this.activeStep.isActive = false;
                step.isActive = true;
                this.onStepChanged.emit(step);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WizardComponent.prototype, "activeStepIndex", {
        get: function () {
            return this.steps.indexOf(this.activeStep);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WizardComponent.prototype, "hasNextStep", {
        get: function () {
            return this.activeStepIndex < this.steps.length - 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WizardComponent.prototype, "hasPrevStep", {
        get: function () {
            return this.activeStepIndex > 0;
        },
        enumerable: true,
        configurable: true
    });
    WizardComponent.prototype.goToStep = function (step) {
        if (!this.isCompleted) {
            this.activeStep = step;
        }
    };
    WizardComponent.prototype.next = function () {
        if (this.hasNextStep) {
            var nextStep = this.steps[this.activeStepIndex + 1];
            this.activeStep.onNext.emit();
            nextStep.isDisabled = false;
            this.activeStep = nextStep;
        }
    };
    WizardComponent.prototype.previous = function () {
        if (this.hasPrevStep) {
            var prevStep = this.steps[this.activeStepIndex - 1];
            this.activeStep.onPrev.emit();
            prevStep.isDisabled = false;
            this.activeStep = prevStep;
        }
    };
    WizardComponent.prototype.complete = function () {
        this.activeStep.onComplete.emit();
        this._isCompleted = true;
    };
WizardComponent.ɵfac = function WizardComponent_Factory(t) { return new (t || WizardComponent)(); };
WizardComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: WizardComponent, selectors: [["form-wizard"]], contentQueries: function WizardComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, wizard_step_component_1.WizardStepComponent, false);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.wizardSteps = _t);
    } }, outputs: { onStepChanged: "onStepChanged" }, ngContentSelectors: _c1, decls: 13, vars: 7, consts: [[1, "card"], [1, "card-header"], [1, "nav", "nav-justified"], ["class", "nav-item", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "card-block"], [1, "card-footer", 3, "hidden"], ["type", "button", 1, "btn", "btn-secondary", "float-left", 3, "hidden", "click"], ["type", "button", 1, "btn", "btn-secondary", "float-right", 3, "disabled", "hidden", "click"], [1, "nav-item", 3, "ngClass"], [3, "click"]], template: function WizardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "ul", 2);
        ɵngcc0.ɵɵtemplate(3, WizardComponent_li_3_Template, 3, 7, "li", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵelementStart(7, "button", 6);
        ɵngcc0.ɵɵlistener("click", function WizardComponent_Template_button_click_7_listener() { return ctx.previous(); });
        ɵngcc0.ɵɵtext(8, "Previous");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "button", 7);
        ɵngcc0.ɵɵlistener("click", function WizardComponent_Template_button_click_9_listener() { return ctx.next(); });
        ɵngcc0.ɵɵtext(10, "Next");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "button", 7);
        ɵngcc0.ɵɵlistener("click", function WizardComponent_Template_button_click_11_listener() { return ctx.complete(); });
        ɵngcc0.ɵɵtext(12, "Done");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.steps);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("hidden", ctx.isCompleted);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.hasPrevStep || !ctx.activeStep.showPrev);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", !ctx.activeStep.isValid)("hidden", !ctx.hasNextStep || !ctx.activeStep.showNext);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", !ctx.activeStep.isValid)("hidden", ctx.hasNextStep);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgClass], styles: [".card[_ngcontent-%COMP%] { height: 100%; }", ".card-header[_ngcontent-%COMP%] { background-color: #fff; padding: 0; font-size: 1.25rem; }", ".card-block[_ngcontent-%COMP%] { overflow-y: auto; }", ".card-footer[_ngcontent-%COMP%] { background-color: #fff; border-top: 0 none; }", ".nav-item[_ngcontent-%COMP%] { padding: 1rem 0rem; border-bottom: 0.5rem solid #ccc; }", ".active[_ngcontent-%COMP%] { font-weight: bold; color: black; border-bottom-color: #1976D2 !important; }", ".enabled[_ngcontent-%COMP%] { cursor: pointer; border-bottom-color: rgb(88, 162, 234); }", ".disabled[_ngcontent-%COMP%] { color: #ccc; }", ".completed[_ngcontent-%COMP%] { cursor: default; }"] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WizardComponent, [{
        type: core_1.Component,
        args: [{
                selector: 'form-wizard',
                template: "<div class=\"card\">\n    <div class=\"card-header\">\n      <ul class=\"nav nav-justified\">\n        <li class=\"nav-item\" *ngFor=\"let step of steps\" [ngClass]=\"{'active': step.isActive, 'enabled': !step.isDisabled, 'disabled': step.isDisabled, 'completed': isCompleted}\">\n          <a (click)=\"goToStep(step)\">{{step.title}}</a>\n        </li>\n      </ul>\n    </div>\n    <div class=\"card-block\">\n      <ng-content></ng-content>\n    </div>\n    <div class=\"card-footer\" [hidden]=\"isCompleted\">\n        <button type=\"button\" class=\"btn btn-secondary float-left\" (click)=\"previous()\" [hidden]=\"!hasPrevStep || !activeStep.showPrev\">Previous</button>\n        <button type=\"button\" class=\"btn btn-secondary float-right\" (click)=\"next()\" [disabled]=\"!activeStep.isValid\" [hidden]=\"!hasNextStep || !activeStep.showNext\">Next</button>\n        <button type=\"button\" class=\"btn btn-secondary float-right\" (click)=\"complete()\" [disabled]=\"!activeStep.isValid\" [hidden]=\"hasNextStep\">Done</button>\n    </div>\n  </div>",
                styles: [
                    '.card { height: 100%; }',
                    '.card-header { background-color: #fff; padding: 0; font-size: 1.25rem; }',
                    '.card-block { overflow-y: auto; }',
                    '.card-footer { background-color: #fff; border-top: 0 none; }',
                    '.nav-item { padding: 1rem 0rem; border-bottom: 0.5rem solid #ccc; }',
                    '.active { font-weight: bold; color: black; border-bottom-color: #1976D2 !important; }',
                    '.enabled { cursor: pointer; border-bottom-color: rgb(88, 162, 234); }',
                    '.disabled { color: #ccc; }',
                    '.completed { cursor: default; }'
                ]
            }]
    }], function () { return []; }, { onStepChanged: [{
            type: core_1.Output
        }], wizardSteps: [{
            type: core_1.ContentChildren,
            args: [wizard_step_component_1.WizardStepComponent]
        }] }); })();
    return WizardComponent;
}());
__decorate([
    core_1.ContentChildren(wizard_step_component_1.WizardStepComponent),
    __metadata("design:type", core_1.QueryList)
], WizardComponent.prototype, "wizardSteps", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], WizardComponent.prototype, "onStepChanged", void 0);
WizardComponent = __decorate([ __metadata("design:paramtypes", [])
], WizardComponent);
exports.WizardComponent = WizardComponent;

//# sourceMappingURL=wizard.component.js.map